import { defaultHorizon, fromAbs, toAbs, type Month } from "@modelcurve/grammar/browser";

// The chart grid, for axes, labels and table columns (display only). "Now" is the server's `as_of`: the
// month we are in. The grid starts the month after and runs to the worldview's horizon. The store sets
// both from each worldview load (`setGrid`), before anything that reads them re-renders; until then they
// follow the browser's clock, as the API does. Month arithmetic and labels are the grammar's.

export { addMonths, fmtByDate, fmtMonth, fromAbs, sortMonths, toAbs, yearOf } from "@modelcurve/grammar/browser";

/** "Sep 30, 2026" for a market rung's calendar date. */
export function fmtDate(date: string): string {
	const [y, m, d] = date.split("-").map(Number);
	return `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][m - 1]} ${d}, ${y}`;
}

function utcMonth(d = new Date()): Month {
	return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}

export let NOW: Month = utcMonth();
export let HORIZON: Month = defaultHorizon(NOW);
let START_ABS = toAbs(NOW) + 1;

/** Index on the chart grid (0 = month after NOW; NOW = -1). */
export function idx(m: Month): number {
	return toAbs(m) - START_ABS;
}

export function monthAt(i: number): Month {
	return fromAbs(START_ABS + i);
}

export let N = idx(HORIZON) + 1;

export let GRID: Month[] = Array.from({ length: N }, (_, i) => monthAt(i));

/** Align the grid with the server's `as_of` and the worldview's horizon. Only the store calls this. */
export function setGrid(asOf: Month, horizon?: Month) {
	NOW = asOf;
	START_ABS = toAbs(NOW) + 1;
	HORIZON = horizon && toAbs(horizon) > toAbs(asOf) ? horizon : defaultHorizon(asOf);
	N = idx(HORIZON) + 1;
	GRID = Array.from({ length: N }, (_, i) => monthAt(i));
}
